/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/panels/enterprise/EnterpriseServerUrl.props" />
export interface IEnterpriseServerUrlProps {
    url: string;
    errorMessage?: string;
    acceptUntrustedSsl: boolean;
    onEnterpriseUrlInputChanged: (value: string) => void;
    onSslChange: (checked: boolean) => void;
    onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}
